// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"471":"f1981a23","487":"6f74c871","488":"5e6baf0b"}[chunkId] + ".chunk.js";
};